import React from 'react';
import { X, RefreshCw } from 'lucide-react';

export const CreditBlockFlowModalLayout: React.FC<{
  title: string;
  submitting: boolean;
  onClose: () => void;
  footer: React.ReactNode;
  children: React.ReactNode;
  panelClassName?: string;
}> = ({ title, submitting, onClose, footer, children, panelClassName = 'max-w-2xl' }) => (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/55"
    onClick={() => {
      if (!submitting) onClose();
    }}
    onKeyDown={(e) => {
      if (e.key === 'Escape' && !submitting) onClose();
    }}
    role="presentation"
  >
    <div
      className={`bg-white dark:bg-gray-800 rounded-lg shadow-2xl w-full ${panelClassName} max-h-[min(92vh,820px)] flex flex-col overflow-hidden`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex-shrink-0 flex items-center justify-between gap-3 px-5 py-3 border-b border-gray-200 dark:border-gray-600">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 truncate">{title}</h3>
        <button
          type="button"
          onClick={onClose}
          disabled={submitting}
          className="flex-shrink-0 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 disabled:opacity-50"
          aria-label="Close"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto px-5 py-4">{children}</div>
      <div className="flex-shrink-0 px-5 py-3 border-t border-gray-200 dark:border-gray-600 flex justify-end bg-gray-50/80 dark:bg-gray-900/40">
        {footer}
      </div>
    </div>
  </div>
);

export const ToolbarFlowSubmitButton: React.FC<{
  label: string;
  submittingLabel: string;
  submitting?: boolean;
  onClick: () => void;
}> = ({ label, submittingLabel, submitting = false, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={submitting}
    className="relative overflow-hidden px-4 py-2 rounded-lg bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-700 hover:to-blue-600 text-white text-sm font-semibold shadow-sm active:scale-[0.98] transition-all disabled:opacity-70 disabled:cursor-not-allowed"
  >
    {submitting && (
      <span className="absolute inset-x-0 bottom-0 h-1 bg-white/25">
        <span className="block h-full w-1/2 bg-white/90 animate-pulse" />
      </span>
    )}
    <span className="relative inline-flex items-center gap-2">
      {submitting ? <RefreshCw className="h-4 w-4 animate-spin" /> : null}
      {submitting ? submittingLabel : label}
    </span>
  </button>
);
